module.exports = __webpack_public_path__ + "img/p2.5df96b1e.png";